module.exports = __webpack_public_path__ + "static/img/celan_btn.76474d09.png";